// @ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
import { MODAL_NAME } from './constants'
import { ClientEditModalParams } from './models/action-params.model'

export const open = ({
  ID,
  hash,
  clientReqFieldGroupID,
  ClientType,
  isPassPhraseRequired,
  ...rest
}: ClientEditModalParams) =>
  LKModalActions.open({
    name: MODAL_NAME,
    ID,
    hash,
    clientType: ClientType,
    groupid: clientReqFieldGroupID,
    isPassPhraseRequired,
    ...rest,
  })
